import type { CidrValidation } from './cidr';

export const WHITELIST_ADDRESS_LABEL_MAX = 16;
export const IP_WHITELIST_COMMENT_MAX = 16;

const DISALLOWED_TEXT_CHARS = /[^\p{L}\p{N} ]+/gu;
const LABEL_BODY = /^[\p{L}\p{N}]+(?: [\p{L}\p{N}]+)*$/u;

export type WhitelistTextValidation = 'ok' | 'invalid';

export const sanitizeWhitelistTextField = (value: string, maxLength: number): string =>
  value.replace(DISALLOWED_TEXT_CHARS, '').slice(0, maxLength);

export const validateWhitelistTextField = (value: string, maxLength: number): WhitelistTextValidation => {
  const trimmed = value.trim();
  if (!trimmed) {
    return 'ok';
  }
  if (trimmed.length > maxLength) {
    return 'invalid';
  }
  if (DISALLOWED_TEXT_CHARS.test(trimmed) || !LABEL_BODY.test(trimmed)) {
    return 'invalid';
  }
  return 'ok';
};

export const cidrValidationMessageKey = (result: CidrValidation): string | null => {
  if (result === 'ok') {
    return null;
  }
  return result === 'too_wide' ? 'security.errors.cidrWide' : 'security.errors.cidrInvalid';
};
